exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FilterVcDemo h4[data-v-10a3e024]{color:#066}.FilterVcDemo .demoItem[data-v-10a3e024]{padding:10px 0;font-size:18px;border-bottom:1px dotted #999}", ""]);

// exports
